<template>
  <div>
    <banner />
    <bannerlist />
  </div>
</template>

<script>
import banner from "../../../components/adminComponent/homepagemanagement/banner/banner";
import bannerlist from "../../../components/adminComponent/homepagemanagement/banner/bannerlist";

export default {
  name: "Banner",
  components: {
    banner,
    bannerlist
  }
};
</script>
